export default __webpack_public_path__ + "static/images/icon-share-wht.png";